import React, { useMemo } from 'react'
import { Operation } from '@user/store/roles/typings'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { OperationListItem } from './OperationListItem'

type Props = {
  operations: Operation[]
  disabled: boolean
  title: string
  onChange: (
    value: boolean,
    permissionType: string,
    operation: string,
    id: number,
  ) => void
}

export function OperationList({
  title,
  operations,
  disabled,
  onChange,
}: Props) {
  const topLevelOperations = useMemo(
    () => operations.filter((s) => !s.parentId),
    [operations],
  )
  const nestedOperations = useMemo(
    () => operations.filter((s) => !!s.parentId),
    [operations],
  )
  return (
    <Box>
      <Typography mb={0.8} mt={3.2} component="div" variant="h7">
        {title}
      </Typography>
      {topLevelOperations.map((operation) => (
        <OperationListItem
          key={operation.id}
          disabled={disabled}
          operation={operation}
          nestedOperations={nestedOperations}
          permissionType={title}
          onChange={onChange}
        />
      ))}
    </Box>
  )
}
